import { apiService } from './api.service';

class SimulationService {
  async getSimulationRuns() {
    try {
      const response = await apiService.get('/simulation/runs');
      return response;
    } catch (error) {
      console.error('Error fetching simulation runs:', error);
      throw error;
    }
  }

  async getSimulationInventory(runId, params = {}) {
    try {
      const response = await apiService.get(`/simulation/runs/${runId}/inventory`, { params });
      return response;
    } catch (error) {
      console.error('Error fetching simulation inventory:', error);
      throw error;
    }
  }

  async getSimulationSuppliers(runId) {
    try {
      const response = await apiService.get(`/simulation/runs/${runId}/suppliers`);
      return response;
    } catch (error) {
      console.error('Error fetching simulation suppliers:', error);
      throw error;
    }
  }

  async getSimulationStores(runId) {
    try {
      const response = await apiService.get(`/simulation/runs/${runId}/stores`);
      return response;
    } catch (error) {
      console.error('Error fetching simulation stores:', error);
      throw error;
    }
  }

  async getStoreTimeline(runId, storeId) {
    try {
      const response = await apiService.get(`/simulation/runs/${runId}/stores/${storeId}/timeline`);
      return response;
    } catch (error) {
      console.error('Error fetching store timeline:', error);
      throw error;
    }
  }
}

export const simulationService = new SimulationService(); 